export default function MetricCard({ label, value, unit, verdict, thresholdHint, statusText = null, detail = null }) {
  const isNoData = verdict === 'no_data';
  const toneClass = verdict === 'fail'
    ? 'border-red-200 bg-red-50/40'
    : verdict === 'borderline'
      ? 'border-amber-200 bg-amber-50/40'
      : isNoData
        ? 'border-slate-200 bg-slate-50/50'
        : 'border-slate-200 bg-white';
  return (
    <div className={`rounded-lg border p-4 shadow-sm ${toneClass}`}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <h3 className="text-sm font-medium text-slate-600">{label}</h3>
          {statusText ? (
            <p className="mt-1 text-2xl font-semibold tabular-nums text-slate-900">{statusText}</p>
          ) : isNoData ? (
            <p className="mt-1 text-2xl font-semibold tabular-nums text-slate-400">Not measured</p>
          ) : (
            <p className="mt-1 text-2xl font-semibold tabular-nums text-slate-900">
              {value}
              {unit ? <span className="ml-1 text-base font-normal text-slate-500">{unit}</span> : null}
            </p>
          )}
          {detail ? (
            <p className="mt-1 text-xs text-slate-500">{detail}</p>
          ) : isNoData ? (
            <p className="mt-1 text-xs text-slate-500">Network conditions prevented this measurement.</p>
          ) : thresholdHint ? (
            <p className="mt-1 text-xs text-slate-500">{thresholdHint}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
}
